// TODO: evaluate calling of EvaluatePossibleNavigationRequests to ensure that display state
// is always updated appropriately (i think we're missing a call after loading a sco), if we
// add this, make sure it's not redundant with the call in ScoUnloaded

/* globals
    $,
    jQuery,
    rscpCfg,
    IntegrationImplementation,
    Communications,
    ScoLoader,
    ActivityRepository,
    Sequencer,
    Control,
    MenuItem,
    ServerFormater,
    XmlElement,
    NavigationRequest,
    PossibleRequest,
    HistoryLog,
    LZString,
    GetUpdatedLastState,
    BuildXmlForDirtyData,
    Debug,
    ConvertIso8601TimeSpanToHundredths,
    GetCurrentConfigurationJs,
    LOOKAHEAD_SEQUENCER_MODE_DISABLE,
    LAUNCH_TYPE_FRAMESET,
    LAUNCH_TYPE_POPUP_AFTER_CLICK,
    LAUNCH_TYPE_POPUP_AFTER_CLICK_WITHOUT_BROWSER_TOOLBAR
    SCORM_TYPE_ASSET,
    DATA_STATE_POSTED,
    DATA_STATE_CLEAN,
    DATA_STATE_DIRTY,
    NAVIGATION_REQUEST_DISPLAY_MESSAGE,
    NAVIGATION_REQUEST_EXIT,
    NAVIGATION_REQUEST_ABANDON,
    NAVIGATION_REQUEST_EXIT_ALL,
    NAVIGATION_REQUEST_SUSPEND_ALL,
    NAVIGATION_REQUEST_ABANDON_ALL,
    NAVIGATION_REQUEST_EXIT_PLAYER,
    NAVIGATION_REQUEST_CONTINUE,
    NAVIGATION_REQUEST_PREVIOUS,
    NAVIGATION_REQUEST_CHOICE,
    NAVIGATION_REQUEST_JUMP,
    NAVIGATION_REQUEST_START,
    NAVIGATION_REQUEST_RESUME_ALL,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_EXIT,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_ABANDON,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_EXIT_ALL,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_SUSPEND_ALL,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_ABANDON_ALL,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_CHOICE,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_CONTINUE,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_PREVIOUS,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_START,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_RESUME_ALL,
    SCORM_RUNTIME_NAV_REQUEST_CONTINUE,
    SCORM_RUNTIME_NAV_REQUEST_PREVIOUS,
    SCORM_RUNTIME_NAV_REQUEST_EXIT,
    SCORM_RUNTIME_NAV_REQUEST_EXITALL,
    SCORM_RUNTIME_NAV_REQUEST_ABANDON,
    SCORM_RUNTIME_NAV_REQUEST_ABANDONALL,
    SCORM_RUNTIME_NAV_REQUEST_SUSPENDALL,
    SCORM_RUNTIME_NAV_REQUEST_NONE,
    RESULT_UNKNOWN
*/
/* eslint-disable new-cap, camelcase */

// eslint-disable-next-line no-unused-vars
function Controller () {
    var menuElement;

    // state data
    this.ProcessedUnload = false;

    // The Scorm 2004 Conformance AutoTest relies on Control.MenuIsVisible when checking
    // the visibility of the menu/Table of Contents
    this.MenuIsVisible = false;
    this.Initialized = false;
    this.ExitScormPlayerCalled = false;
    this.FatalErrorEncountered = false;
    this.SignalTerminatedPending = false;
    // Indicates that the SCO popup was blocked by a popup blocker
    this.PopupBlocked = false;
    this.ExitDialogVisible = false;
    this.ShouldSaveClientDebugLogs = false;
    this.SendDebugLogsAsJson = false;

    /* eslint-disable no-use-before-define */

    // overall processing
    this.Initialize = Controller_Initialize;
    this.Unload = Controller_Unload;
    this.BeforeUnload = Controller_BeforeUnload;
    this.MustUnload = Controller_MustUnload;

    // menu functions
    this.CreateMenuItem = Controller_CreateMenuItem;
    this.RenderMenuItem = Controller_RenderMenuItem;
    this.RedrawChildren = Controller_RedrawChildren;
    this.UpdateDisplay = Controller_UpdateDisplay;
    this.RefreshPage = Controller_RefreshPage;

    // activity
    this.Activities = null;

    // time limit
    this.CheckTimeLimitIntervalId = null;
    this.IsUserOverTimeLimit = Controller_IsUserOverTimeLimit;
    this.ExitIfTimeLimitExceeded = Controller_ExitIfTimeLimitExceeded;
    this.BlockCourseEntryWithMessage = Controller_BlockCourseEntryWithMessage;

    // logistics
    this.ScoLoader = null;
    this.ScoUnloaded = Controller_ScoUnloaded;
    this.ExitScormPlayer = Controller_ExitScormPlayer;
    this.ExitSco = Controller_ExitSco;

    // dirty data management
    this.LastState = null;
    this.MarkPostedDataDirty = Controller_MarkPostedDataDirty;
    this.MarkPostedDataClean = Controller_MarkPostedDataClean;
    this.MarkDirtyDataPosted = Controller_MarkDirtyDataPosted;
    this.PrepareResultsPayload = Controller_PrepareResultsPayload;
    this.GetXmlForDirtyData = Controller_GetXmlForDirtyData;
    this.IsThereDirtyData = Controller_IsThereDirtyData;
    this.DoCommit = Controller_DoCommit;
    this.GetDeltaXmlForDirtyData = Controller_GetDeltaXmlForDirtyData;
    this.UpdateLastState = Controller_UpdateLastState;

    // error management
    this.DisplayError = Controller_DisplayError;
    this.GetExceptionText = Controller_GetExceptionText;
    this.CheckForDebugCommand = Controller_CheckForDebugCommand;

    // GUI Event Handlers
    this.CloseSco = Controller_CloseSco;
    this.ReturnToLms = Controller_ReturnToLms;
    this.GetReturnToLmsNavigationRequest = Controller_GetReturnToLmsNavigationRequest;
    this.ToggleMenuVisibility = Controller_ToggleMenuVisibility;
    this.TriggerReturnToLMS = Controller_TriggerReturnToLMS;
    this.TriggerLegacyReturnToLMS = Controller_TriggerLegacyReturnToLMS;
    this.HideExitDialog = Controller_HideExitDialog;

    // The Scorm 2004 Conformance AutoTest relies on Control.Next being the handler
    // for a next request
    this.Next = Controller_Next;

    // The Scorm 2004 Conformance AutoTest relies on Control.Previous being the handler
    // for a previous request
    this.Previous = Controller_Previous;
    this.Abandon = Controller_Abandon;
    this.AbandonAll = Controller_AbandonAll;
    this.Suspend = Controller_Suspend;
    this.Exit = Controller_Exit;
    this.ExitAll = Controller_ExitAll;

    // The Scorm 2004 Conformance AutoTest relies on Control.ChoiceRequest(id) being the
    // handler for clicking an activity
    this.ChoiceRequest = Controller_ChoiceRequest;

    this.ScoHasTerminatedSoUnload = Controller_ScoHasTerminatedSoUnload;
    this.SignalTerminated = Controller_SignalTerminated;
    this.TranslateRunTimeNavRequest = Controller_TranslateRunTimeNavRequest;
    this.FindPossibleNavRequestForRuntimeNavRequest = Controller_FindPossibleNavRequestForRuntimeNavRequest;
    this.GetMessageText = Controller_GetMessageText;
    this.HandleRedirectIfRequired = Controller_HandleRedirectIfRequired;

    this.ClearPendingNavigationRequest = Controller_ClearPendingNavigationRequest;
    this.IsThereAPendingNavigationRequest = Controller_IsThereAPendingNavigationRequest;
    this.PendingNavigationRequest = null;

    this.GetPreferredReturnToLmsAction = Controller_GetPreferredReturnToLmsAction;

    this.UpdateGlobalLearnerPrefs = Controller_UpdateGlobalLearnerPrefs;

    // Sequencing
    this.Sequencer = null;
    this.LookAheadSequencer = null;
    this.DeliverActivity = Controller_DeliverActivity;
    this.PerformDelayedDeliveryInitialization = Controller_PerformDelayedDeliveryInitialization;

    this.PossibleNavigationRequests = [];
    this.InitializePossibleNavigationRequests = Controller_InitializePossibleNavigationRequests;
    this.EvaluatePossibleNavigationRequests = Controller_EvaluatePossibleNavigationRequests;
    this.FindPossibleChoiceRequestForActivity = Controller_FindPossibleChoiceRequestForActivity;
    this.GetPossibleContinueRequest = Controller_GetPossibleContinueRequest;
    this.GetPossiblePreviousRequest = Controller_GetPossiblePreviousRequest;

    this.IsTargetValid = Controller_IsTargetValid;
    this.ParseTargetStringIntoActivity = Controller_ParseTargetStringIntoActivity;
    this.IsChoiceRequestValid = Controller_IsChoiceRequestValid;
    this.IsJumpRequestValid = Controller_IsJumpRequestValid;
    this.IsContinueRequestValid = Controller_IsContinueRequestValid;
    this.IsPreviousRequestValid = Controller_IsPreviousRequestValid;
    this.ParseTargetStringFromChoiceRequest = Controller_ParseTargetStringFromChoiceRequest;

    this.CloneSequencer = Controller_CloneSequencer;
    this.TearDownSequencer = Controller_TearDownSequencer;

    // Runtime
    this.Api = null;

    // Debug
    this.WriteAuditLog = Controller_WriteAuditLog;
    this.WriteDetailedLog = Controller_WriteDetailedLog;
    this.WriteDetailedLogError = Controller_WriteDetailedLogError;
    this.WriteHistoryLog = Controller_WriteHistoryLog;
    this.WriteHistoryReturnValue = Controller_WriteHistoryReturnValue;

    // History Log
    this.GetLaunchHistoryId = Controller_GetLaunchHistoryId;

    /* eslint-enable no-use-before-define */

    // SSP
    this.SSPBuckets = null;

    // message for NoOp redirect
    this.NoOpRedirectMsg = "";

    // Token added to compressed RecordResults payload
    this.CompressionIndicatorToken = "<COMP2>";

    //
    // trying to initialize the controller without the root menu element will
    // result in an Initialization error, but usually it is a timing issue
    // where the frame containing that element just hasn't loaded yet, so
    // throw an error here which will be caught in the integration loader,
    // and this constructor will get recalled and hopefully on a future pass
    // that element has been loaded and can be found which will trigger
    // initialization
    //
    menuElement = IntegrationImplementation.GetHtmlElementToInsertMenuWithin();
    if (menuElement === null) {
        throw new Error("IntegrationImplementation.GetHtmlElementToInsertMenuWithin() returned null");
    }
}

function checkForDeprecatedIntegrationFunctions () {
    if (typeof IntegrationImplementation.PopulateMenuItemDivTag !== "undefined") {
        throw new Error("Deprecated function in integration 'PopulateMenuItemDivTag' replace with 'PopulateMenuItemElement'");
    }
}

//
// Given a relative page href and the full href to the current delivery page,
// this function will construct a full href relative to the delivery page.
//
function BuildFullUrl (relativeHref, deliveryPageUrl) {
    var deliveryPagePathWithoutQueryString,
        baseHref;

    if (deliveryPageUrl.indexOf("?") > -1) {
        deliveryPagePathWithoutQueryString = deliveryPageUrl.substr(0, deliveryPageUrl.indexOf("?"));
    }
    else {
        deliveryPagePathWithoutQueryString = deliveryPageUrl;
    }

    baseHref = deliveryPageUrl.substr(0, deliveryPagePathWithoutQueryString.lastIndexOf("/"));

    //
    // The relative href might contain ../ to move up a directory. If so, we must adjust
    // the baseHref appropriately
    //
    while (relativeHref.indexOf("../") > -1) {
        relativeHref = relativeHref.substr(3, relativeHref.length);
        baseHref = baseHref.substr(0, baseHref.lastIndexOf("/"));
    }

    return baseHref + "/" + relativeHref;
}

// eslint-disable-next-line complexity
function Controller_Initialize (apiReference) {
    var suspendedActivity,
        isPreview,
        deliveryPageUrl,
        msgStr,
        clonedIntermediatePage = rscpCfg.get("intermediatePage").clone(),
        clonedPopupLauncherPage = rscpCfg.get("popupLauncherPage").clone(),
        registrationToDeliver = rscpCfg.get("registrationToDeliver"),
        intermediatePageLoadAtStart = rscpCfg.get("intermediatePageLoadAtStart"),
        self = this;

    try {
        this.WriteAuditLog("Control Initialize");

        if (rscpCfg.get("shouldSaveClientDebugLogs")) {
            this.ShouldSaveClientDebugLogs = true;
        }
        if (rscpCfg.get("sendDebugLogsAsJson")) {
            this.SendDebugLogsAsJson = true;
        }

        this.Api = apiReference;
        this.Package = registrationToDeliver.Package;

        this.Activities = new ActivityRepository();
        this.Activities.InitializeFromRegistration(registrationToDeliver, rscpCfg.get("querystringAdditions"));

        this.Sequencer = new Sequencer(false, this.Activities);
        this.Sequencer.GlobalObjectives = registrationToDeliver.GlobalObjectives;
        this.Sequencer.SharedData = registrationToDeliver.SharedData;
        this.Sequencer.Activities.SetSequencer(this.Sequencer, false);

        this.SSPBuckets = registrationToDeliver.SSPBuckets;

        this.SharedData = registrationToDeliver.SharedData;

        this.DeliverFramesetUnloadEventCalled = false;

        // eslint-disable-next-line no-eq-null, eqeqeq
        if (rscpCfg.get("sspEnabled") && this.Api.SSPApi != null) {
            this.Api.SSPApi.InitializeBuckets();
        }

        if (rscpCfg.get("useDeltaRecordResultsPayload") === true) {
            // store last state on init so that a large initial state
            // is not sent as the first postback for delta postbacks
            this.UpdateLastState(this.GetXmlForDirtyData(true));
        }

        this.InitializePossibleNavigationRequests();

        suspendedActivity = this.Activities.GetActivityByDatabaseId(registrationToDeliver.SuspendedActivity);
        this.Sequencer.SetSuspendedActivity(suspendedActivity);

        this.Sequencer.InitialRandomizationAndSelection();

        this.CreateMenuItem(null, this.Activities.ActivityTree, IntegrationImplementation.GetDocumentObjectForMenu());

        this.RenderMenuItem(this.Activities.ActivityTree);

        IntegrationImplementation.SetMenuToggleVisibility(this.Package.Properties.ShowCourseStructure);

        if (this.Package.Properties.ShowCourseStructure === true && this.Package.Properties.CourseStructureStartsOpen === true) {
            // intialized as false
            this.ToggleMenuVisibility();
        }
        else {
            IntegrationImplementation.HideMenu();
        }

        this.LookAheadSequencer = new Sequencer(true, this.Sequencer.Activities.Clone());
        this.LookAheadSequencer.Activities.SetSequencer(this.LookAheadSequencer, true);

        this.Comm = new Communications();

        // errors thrown before this point won't get recorded on the server and may cause the debugger
        // to fail to render
        checkForDeprecatedIntegrationFunctions();

        isPreview = rscpCfg.get("extRegId") === "";

        //
        // If we're launching an AICC course or an xAPI based course, then we don't want to send any posts to the server,
        // the content will take care of it
        //
        // Also disable communications if the registration is in preview mode (indicated by the lack of an external reg id).
        // Note that "review" mode where isTracking=false does NOT disable communications since we still want to
        // postback history logs.
        //
        if (isPreview || this.Package.LearningStandard.isAICC() || this.Package.LearningStandard.isCmi5() || this.Package.LearningStandard.isTinCan() || this.Package.LearningStandard.isLti()) {
            this.Comm.Disable();
        }
        else {
            //
            // if comms are not disabled, then kick off the Dispatch handling
            // once here before the content has a chance to change things so
            // the initial launch state is piped through to the client to
            // properly initialize the client state
            //
            this.Comm.SendDispatchMessagesIfNeeded(true);
        }

        this.Comm.StartPostDataProcess();
        this.Comm.StartWatchProcess();

        //
        // Build full URL's using the relative URLs for Intermediate and Popup pages.  These files will be found
        // relative to the deliver page itself.  Fully qualified urls are built due to an incompatability within
        // Safari using relative URLs.
        //
        deliveryPageUrl = window.location.toString();
        clonedIntermediatePage.PageHref = BuildFullUrl(clonedIntermediatePage.PageHref, deliveryPageUrl);
        clonedPopupLauncherPage.PageHref = BuildFullUrl(clonedPopupLauncherPage.PageHref, deliveryPageUrl);

        this.ScoLoader = new ScoLoader(
            clonedIntermediatePage,
            clonedPopupLauncherPage,
            rscpCfg.get("pathToCourse"),
            registrationToDeliver.Package.Properties.ScoLaunchType,
            registrationToDeliver.Package.Properties.WrapScoWindowWithApi,
            registrationToDeliver.Package.LearningStandard
        );

        this.Initialized = true;

        // If time limit specified, and exceeded, stop them here
        if (this.Package.Properties.TimeLimit > 0 && this.IsUserOverTimeLimit()) {
            this.WriteAuditLog("Time limit exceeded, blocking entry to course");
            this.BlockCourseEntryWithMessage(
                IntegrationImplementation.GetString("The time limit for this course has been exceeded.")
            );
        }
        // Otherwise, carry on like normal, start sequencer, etc
        else {
            //
            // Chrome seems to have an issue loading the intermediate page and calling
            // its `load` function preventing SCO delivery (which is often called by
            // the sequencer's start routine to load initial SCO) from setting the
            // location of the content frame where the intermediate page is running,
            // by using a timeout here it gets "unblocked" and normal execution occurs,
            // using even 1 ms seems to be enough to prevent hang in most cases, 200ms
            // seemed to always prevent it, which likely means it is a synchronization
            // problem rather than a timing one
            //
            // using `self` here in attempt to continue to support IE 8 which doesn't
            // support `.bind`
            //
            window.setTimeout(
                function () {
                    self.Sequencer.Start();

                    // TODO: make it an option to invoke the look ahead sequencer asychronously
                    // (can improve apparent load speed on very large courses)
                    // window.setTimeout("Control.EvaluatePossibleNavigationRequests()", 1);
                    self.EvaluatePossibleNavigationRequests();

                    // Implement time limit checking, if set above default of 0
                    if (self.Package.Properties.TimeLimit > 0) {
                        // eslint-disable-next-line no-implied-eval
                        self.CheckTimeLimitIntervalId = setInterval("Control.ExitIfTimeLimitExceeded()", 5000);
                    }
                },
                intermediatePageLoadAtStart ? 200 : 1
            );
        }
    }
    catch (error) {
        msgStr = "Controller_Initialize Error: ";
        if (typeof registrationToDeliver !== "undefined" && typeof registrationToDeliver.Id !== "undefined") {
            msgStr = msgStr + "RegistrationId: " + registrationToDeliver.Id + ", ";
        }

        // Send log message back to server, but eat any errors because we want to
        // ensure the subsequent message and player exit always occur.
        try {
            this.Comm.LogOnServer(msgStr, error);
        }
        catch (loggingError) {
            // Eat it, we're on our way out...
        }

        this.WriteDetailedLogError(msgStr + error);

        Control.DisplayError("A fatal error has occurred during player initialization. Exiting.");

        // Go ahead and exit the player to remove the possibility of somebody continuing with the course and
        // not having their data persisted.
        this.FatalErrorEncountered = true;

        if (Control.Package.Properties.PlayerLaunchType === LAUNCH_TYPE_FRAMESET) {
            Control.HandleRedirectIfRequired(window);
        }
        else {
            // Protect against case where the top level window is killed/closed.
            if (window.opener && window.opener !== null && window.opener.closed === false) {
                Control.HandleRedirectIfRequired(window.opener);
            }
            window.close();
        }

        throw error;
    }
}

//
// Return true if the player window must not be prevented from unloading by the BeforeUnload
// method. This will be the case if the unload is triggered by the player itself, rather than
// by the user closing the window or navigating away.
//
function Controller_MustUnload () {
    return this.ExitScormPlayerCalled || this.FatalErrorEncountered;
}

//
// Interrupt the normal onbeforeunload/unload process if the player window is closed directly
// (i.e., not through ExitScormPlayer calling window.close()), and we're configured to prompt
// the user for confirmation before closing.
//
function Controller_BeforeUnload () {
    if (! this.MustUnload() && rscpCfg.get("shouldPromptOnClose")) {
        return IntegrationImplementation.GetString("Leaving this page may result in lost progress.");
    }

    return this.Unload();
}

//
// Unload is triggered by the deliver page's onbeforeunload, onunload, and onpagehide events. Most likely
// the onbeforeunload is the only real time it's used since the subsequent call will exit early.
//
function Controller_Unload () {
    var registrationToDeliver = rscpCfg.get("registrationToDeliver"),
        msgStr,
        preUnloadedSequencer,
        preUnloadedCurrentActivity,
        preUnloadSessionTime,
        preUnloadTotalTime,
        preUnloadTotalTimeTracked,
        preUnloadEntry,
        preUnloadCompletionStatus,
        preUnloadCompletionStatusChangedDuringRuntime,
        preUnloadSuccessStatus,
        preUnloadSuccessStatusChangedDuringRuntime,
        preUnloadNavRequest;

    try {
        this.WriteAuditLog("Control Unload: this.ProcessedUnload=" + this.ProcessedUnload + ", this.ExitScormPlayerCalled=" + this.ExitScormPlayerCalled + ", this.Api.NeedToCloseOutSession()=" + this.Api.NeedToCloseOutSession());

        // Unload is called in three spots, onbeforeunload, onunload, and onpagehide of the deliver page so
        // this variable basically just indicates that onbeforeunload has already been called.
        // Note that Chrome can try to run onbeforeunload, onunload, and onpagehide at the same time so use
        // the early DeliverFramesetUnloadEventCalled variable here rather than ProcessedUnload

        // Add AICC Check to help deal with the AICC multi-AU unload hitting Exit URL
        if (this.DeliverFramesetUnloadEventCalled || this.RefreshPageForAiccCalled) {
            return;
        }

        this.DeliverFramesetUnloadEventCalled = true;

        //
        // We want the sequencer to behave as if ReturnToLms was invoked. This will cause rollup
        // to occur upon suspend_all even with the package property for "Rollup at Suspend All" is
        // false. It matches 2010.1.x FinalExitHandler behavior.
        // this.Sequencer.ReturnToLmsInvoked = true;  Only do this if the content didn't explicitly
        // set an adl.nav.request.
        //
        if (this.Api !== null && this.Api.RunTimeData !== null && this.Api.RunTimeData.NavRequest === SCORM_RUNTIME_NAV_REQUEST_NONE) {
            this.Sequencer.ReturnToLmsInvoked = true;
        }

        //
        // Just always call it. If it's a popup, it'll be benign. If it's the intermediate page
        // it'll just reload the intermediate page but there's protection now in the intermediate
        // to not call ScoUnloaded if it's already been done. The point of this is to not only
        // ensure the physical window is closed in the case of a popup, but more importantly,
        // to tear down the window a bit earlier to give the onbeforeunload, onunload, and onpagehide content
        // event handlers a better chance of running.
        //
        this.ScoLoader.UnloadSco();

        // We mark this event here, after the course content has exited so that
        // any api calls it makes while being unloaded will hit the log first
        // We mark in both ScoUnload() and here, report doesn't mind if it gets extra
        this.WriteHistoryLog("", {ev: "Unload"});

        // for offline use
        if (typeof GetCurrentConfigurationJs !== "undefined") {
            localStorage.configurationJs = GetCurrentConfigurationJs();
            localStorage.runtimeXml = Control.GetXmlForDirtyData();
        }

        if (this.ScoLoader.ScoLoaded && ! this.PopupBlocked) {
            // Clone the sequencer
            preUnloadedSequencer = new Sequencer(false, this.Sequencer.Activities.Clone());
            preUnloadedCurrentActivity = this.Sequencer.CurrentActivity;

            // Save off the API values that might get altered via CloseOutSession (may be called by ScoUnloaded)
            preUnloadSessionTime = this.Api.RunTimeData.SessionTime;
            preUnloadTotalTime = this.Api.RunTimeData.TotalTime;
            preUnloadTotalTimeTracked = this.Api.RunTimeData.TotalTimeTracked;
            preUnloadEntry = this.Api.RunTimeData.Entry;
            preUnloadCompletionStatus = this.Api.RunTimeData.CompletionStatus;
            preUnloadCompletionStatusChangedDuringRuntime = this.Api.RunTimeData.CompletionStatusChangedDuringRuntime;
            preUnloadSuccessStatus = this.Api.RunTimeData.SuccessStatus;
            preUnloadSuccessStatusChangedDuringRuntime = this.Api.RunTimeData.SuccessStatusChangedDuringRuntime;
            preUnloadNavRequest = this.Api.RunTimeData.NavRequest;

            //
            // Since Unload has been processed it means we're tearing down windows now. So set the return
            // to lms nav request in a legacy manner that prevents any user-selectable alerts which could
            // short circuit processing of the overall sequencer we're trying to get to. This nav request
            // mimics a click of "return to lms"
            //
            if (this.Activities.GetNumDeliverableActivities() === 1) {
                this.PendingNavigationRequest = this.GetReturnToLmsNavigationRequest("exit_all");
            }
            else {
                this.PendingNavigationRequest = this.GetReturnToLmsNavigationRequest("suspend_all");
            }

            // will ultimately trigger the OverallSequencingProcess and thus activity rollup
            // it also will close out the session if the content didn't call finish
            this.ScoUnloaded("Unload()");

            // This allows us to return to a state from which a subsequent Finish/Terminate call from a
            // SCO's window onbeforeunload, onunload, and onpagehide event could be serviced correctly. A Sequencer,
            // particularly form SCORM 2004 cannot be run more than once without side effects.
            // This is why we're reverting to the previous state -- to allow for a subsequent run.
            this.Sequencer = preUnloadedSequencer;
            this.Sequencer.CurrentActivity = preUnloadedCurrentActivity;

            this.Api.RunTimeData.SessionTime = preUnloadSessionTime;
            this.Api.RunTimeData.TotalTime = preUnloadTotalTime;
            this.Api.RunTimeData.TotalTimeTracked = preUnloadTotalTimeTracked;
            this.Api.RunTimeData.Entry = preUnloadEntry;
            this.Api.RunTimeData.CompletionStatus = preUnloadCompletionStatus;
            this.Api.RunTimeData.CompletionStatusChangedDuringRuntime = preUnloadCompletionStatusChangedDuringRuntime;
            this.Api.RunTimeData.SuccessStatus = preUnloadSuccessStatus;
            this.Api.RunTimeData.SuccessStatusChangedDuringRuntime = preUnloadSuccessStatusChangedDuringRuntime;
            this.Api.RunTimeData.NavRequest = preUnloadNavRequest;
            this.Api.CloseOutSessionCalled = false;

            this.ScoLoader.ScoLoaded = true;

            // Is this necessary? Test new win, new win and kill middle window on all browsers to test.
            if (this.SignalTerminatedPending) {
                this.Api.CloseOutSessionCalled = true;
                this.SignalTerminated();
            }
        }

        if (! this.ExitScormPlayerCalled) {
            // Some sequencing paths such as simply "close item" will not have resulted in ExitScormPlayer
            this.ExitScormPlayer("Unload()");
        }

        // This is part of resetting the state so a lagging Api.Terminate() can do its thing as if unload
        // had never run
        this.ExitScormPlayerCalled = false;

        this.ProcessedUnload = true;
    }
    catch (error) {
        msgStr = "Controller_Unload Error: ";
        if (typeof registrationToDeliver !== "undefined" && typeof registrationToDeliver.Id !== "undefined") {
            msgStr = msgStr + "RegistrationId: " + registrationToDeliver.Id + ", ";
        }
        this.Comm.LogOnServer(msgStr, error);
        throw error;
    }
}

// private
function Controller_CreateMenuItem (parentMenuItem, activity, documentObject) {
    var availableChildren,
        childActivity;

    activity.MenuItem = new MenuItem(parentMenuItem, activity, documentObject);

    if (parentMenuItem !== null) {
        parentMenuItem.Children[parentMenuItem.Children.length] = activity.MenuItem;
    }

    availableChildren = activity.GetAvailableChildren();

    for (childActivity in availableChildren) {
        if (availableChildren.hasOwnProperty(childActivity)) {
            this.CreateMenuItem(activity.MenuItem, availableChildren[childActivity], documentObject);
        }
    }
}

// private
function Controller_RenderMenuItem (activity) {
    var childActivities,
        childActivity;

    //
    // This seems odd, but the activity is now a param to Render(). The reason being is that,
    // while the activity has an associated MenuItem, it's now possible that different activity
    // data can be used to render it (main sequencer or lookahead). As such, the activity object
    // is no longer a local member of MenuItem, thus we need to pass it in.
    //
    activity.MenuItem.Render(activity);

    childActivities = activity.GetAvailableChildren();

    for (childActivity in childActivities) {
        if (childActivities.hasOwnProperty(childActivity)) {
            this.RenderMenuItem(childActivities[childActivity]);
        }
    }
}

// protected - available to sequencing functions only
function Controller_RedrawChildren (activity) {
    activity.MenuItem.ResynchChildren(activity);
    this.RenderMenuItem(activity);
}

// private
// eslint-disable-next-line complexity
function Controller_UpdateDisplay (useLookAheadDataNavInfo, useLookAheadActivityStatus) {
    var logParent = this.WriteAuditLog("Control Update Display"),
        visibleMenuItemCount = 0,
        navigationRequestInfo,
        activity,
        activityId,
        menuItem,
        currentMenuItem,
        parentActivity,
        currentIsHighlighted;

    //
    // We have two uses for lookahead data
    // 1. We want it's navigation choice result so use the looahead to say "what would happen".
    //    We can use this to appropriately display a link
    // 2. While we're inside a sco, before exiting and after each commit we run the lookahead
    //    sequencer. The activity status data at that moment is more valid/up-to-date than the
    //    main sequencer. So we want to use lookahead activity data after commits.
    //

    // Make sure input params are usable
    if (this.Package.Properties.LookaheadSequencerMode === LOOKAHEAD_SEQUENCER_MODE_DISABLE) {
        useLookAheadDataNavInfo = false;
        useLookAheadActivityStatus = false;
    }
    else {
        if (typeof useLookAheadDataNavInfo === "undefined" || useLookAheadDataNavInfo === null) {
            useLookAheadDataNavInfo = false;
        }
        if (typeof useLookAheadActivityStatus === "undefined" || useLookAheadActivityStatus === null) {
            useLookAheadActivityStatus = false;
        }
    }

    this.WriteDetailedLog("Updating display for each menu item", logParent);

    for (activityId in this.Sequencer.Activities.ActivityList) {
        if (this.Sequencer.Activities.ActivityList.hasOwnProperty(activityId)) {
            if (useLookAheadActivityStatus) {
                activity = this.LookAheadSequencer.Activities.ActivityList[activityId];
            }
            else {
                activity = this.Sequencer.Activities.ActivityList[activityId];
            }

            if (useLookAheadDataNavInfo) {
                navigationRequestInfo = this.FindPossibleChoiceRequestForActivity(this.LookAheadSequencer.Activities.ActivityList[activityId]);
            }
            else {
                navigationRequestInfo = this.FindPossibleChoiceRequestForActivity(this.Sequencer.Activities.ActivityList[activityId]);
            }

            activity.SetHiddenFromChoice(navigationRequestInfo.Hidden);

            //
            // There's only one real set of menu items and these are attached to the main sequencer,
            // so always use "this.Sequencer" when using MenuItems
            //
            menuItem = this.Sequencer.Activities.ActivityList[activityId].MenuItem;

            //
            // menu items do not get created for activities that are not selected in the selection
            // and randomization process
            //
            if (menuItem !== null) {
                menuItem.UpdateStateDisplay(
                    activity,
                    this.Sequencer.CurrentActivity,
                    navigationRequestInfo,
                    useLookAheadActivityStatus
                );
                if (menuItem.Visible) {
                    visibleMenuItemCount += 1;
                }
            }
        }
    }

    //
    // if the menu item for the current activity isn't visible, we want to make the first parent
    // that is visible show as active
    //
    if (visibleMenuItemCount > 0 && this.Sequencer.CurrentActivity !== null) {
        currentMenuItem = this.Sequencer.CurrentActivity.MenuItem;

        if (currentMenuItem.Visible === false && currentMenuItem.CurrentDisplayState.ActiveDisplayed === true) {
            parentActivity = this.Sequencer.CurrentActivity.ParentActivity;
            currentIsHighlighted = false;

            while (parentActivity !== null && currentIsHighlighted === false) {
                if (parentActivity.MenuItem.Visible === true) {
                    //
                    // parent is visible, call UpdateStateDisplay and pass the parent activity in as
                    // the current activity so it gets displayed as such
                    //
                    // eslint-disable-next-line max-depth
                    if (useLookAheadDataNavInfo) {
                        navigationRequestInfo = this.FindPossibleChoiceRequestForActivity(this.LookAheadSequencer.Activities.ActivityList[activityId]);
                    }
                    else {
                        navigationRequestInfo = this.FindPossibleChoiceRequestForActivity(this.Sequencer.Activities.ActivityList[activityId]);
                    }

                    parentActivity.MenuItem.UpdateStateDisplay(parentActivity, parentActivity, navigationRequestInfo, useLookAheadActivityStatus);
                    currentIsHighlighted = true;
                }
                else {
                    parentActivity = parentActivity.ParentActivity;
                }
            }
        }
    }

    //
    // NOTE: The UpdateControlState should always take the "real" non-lookahead sequencer because
    // we need static data off the real current activity
    //
    this.WriteDetailedLog("Calling Integration Implementation UpdateControl State", logParent);
    IntegrationImplementation.UpdateControlState(IntegrationImplementation.GetDocumentObjectForControls(), this.PossibleNavigationRequests, this.Sequencer.GetCurrentActivity());
    if (useLookAheadActivityStatus) {
        IntegrationImplementation.UpdateProgressBar(
            IntegrationImplementation.GetDocumentObjectForControls(),
            this.LookAheadSequencer.GetCurrentActivity()
        );
    }
    else {
        IntegrationImplementation.UpdateProgressBar(
            IntegrationImplementation.GetDocumentObjectForControls(),
            this.Sequencer.GetCurrentActivity()
        );
    }

    if (visibleMenuItemCount === 0) {
        if (this.MenuIsVisible === true) {
            this.ToggleMenuVisibility();
        }
    }
    else if (this.Package.Properties.ShowCourseStructure === true
        && this.Package.Properties.CourseStructureStartsOpen === true
        && this.MenuIsVisible === false
    ) {
        this.ToggleMenuVisibility();
    }

    // This allows the customer to completely customize the look and feel of the menu for multi sco courses.
    if (typeof IntegrationImplementation.OverrideMenuLookAndFeel !== "undefined") {
        IntegrationImplementation.OverrideMenuLookAndFeel(IntegrationImplementation.GetDocumentObjectForMenu());
    }

    this.WriteDetailedLog("Exiting Control Update Display", logParent);
}

// private
function Controller_RefreshPage () {
    //
    // called to update the AICC data which resides on the server
    //

    // TODO: improvement would be to keep the page loaded and just pull down the updated state data via xmlhttp

    // find the top level window for the player...the window with the Control object
    var MAX_PARENTS_TO_SEARCH = 500,
        nParentsSearched = 0,
        win = window;

    //
    // Set this value to read later to avoid hitting the RediectOnExitUrl when unloading
    // modules in a multi module AICC course
    //
    this.RefreshPageForAiccCalled = true;

    while (win.Control === null && win.parent !== null && win.parent !== win && nParentsSearched <= MAX_PARENTS_TO_SEARCH) {
        nParentsSearched += 1;
        win = win.parent;
    }

    if (typeof win.Control === "undefined" || win.Control === null) {
        Debug.AssertError("Could not locate the top level window.");
    }
    else {
        win.location.replace(win.location);
    }
}

//
// This method is a big deal. It's responsible for calling the overall sequencing process.
// It's also responsible for closing out the API session if the content failed to do so. This
// should only get called once per Activity otherwise, particularly for SCORM 2004, we open
// ourselves up to errors. This is why when Unload() calls this method, it clones the sequencer
// beforehand and returns that state after calling this method in case a straggling API.Finish()
// is called after the fact at shutdown time.
//
function Controller_ScoUnloaded (caller) {
    var logParent = this.WriteAuditLog("Control ScoUnloaded called by " + caller),
        aryParentActivities,
        i;

    //
    // We mark this event here, after the course content has exited so that
    // any api calls it makes while being unloaded will hit the log first
    //
    this.WriteHistoryLog("", {ev: "ScoUnloaded"});

    //
    // called from the intermediate page when it loads...this signals that the last SCO has
    // completely unloaded and thus finished its processing
    //

    //
    // make sure that things are loaded and ready...the intermediate page loads with the initial
    // frameset and might slip in an extra call here on initial load
    //
    if (this.Initialized === false) {
        return;
    }

    //
    // Because multiple process might be in play guard against calling this twice here. But need to
    // find an actual problem case before using this as it seems to cause autotest problems.
    // if (! this.ScoLoader.ScoLoaded) {
    //     return;
    // }

    this.ScoLoader.ScoLoaded = false;

    //
    // check to make sure that the SCO called Finish/Terminate. Note the value for NeedToCloseOutSession
    // is a bit misleading, false means we do need to close out the session
    //
    if (this.Api.Activity !== null && this.Api.NeedToCloseOutSession()) {
        //
        // Don't call CloseOutSession unless the Api has been initialized.
        // Doing so may cause errors due to uninitialized values
        //
        if (this.Api.Initialized) {
            this.Api.CloseOutSession("ScoUnloaded() because apparently Finish/Terminate wasn't called");
            this.Api.SetDirtyData();
        }
    }

    if (this.Api.Activity !== null && this.Api.Activity.LearningObject.ScormType === SCORM_TYPE_ASSET && this.Api.Activity.WasLaunchedThisSession()) {
        this.Api.AccumulateTotalTimeTracked();
        this.WriteDetailedLog("New Tracked Total Time for Asset: " + this.Api.RunTimeData.TotalTimeTracked);

        // Recalculate duration timings for each parent of this asset
        aryParentActivities = this.Sequencer.Activities.GetActivityPath(this.Api.Activity, false);
        for (i = 0; i < aryParentActivities.length; i += 1) {
            aryParentActivities[i].RollupDurations();
        }
    }

    //
    // use the user's navigation request if it exists, otherwise, check the runtime for a nav request
    // by the SCO, then try to determine the appropriate rudimentary sequencing request (exit action)
    //
    if (this.PendingNavigationRequest === null) {
        if (this.Api !== null && this.Api.RunTimeData !== null && this.Api.RunTimeData.NavRequest !== SCORM_RUNTIME_NAV_REQUEST_NONE) {
            this.WriteDetailedLog("API Runtime Nav Request Detected = " + this.Api.RunTimeData.NavRequest, logParent);

            this.PendingNavigationRequest = this.TranslateRunTimeNavRequest(this.Api.RunTimeData.NavRequest);
        }
    }

    this.Sequencer.NavigationRequest = this.PendingNavigationRequest;

    this.ClearPendingNavigationRequest();

    // If this integration point is defined, run it
    if (typeof IntegrationImplementation.PreOverallSequencingProcess !== "undefined"
        && IntegrationImplementation.PreOverallSequencingProcess !== null
        && IntegrationImplementation.PreOverallSequencingProcess
    ) {
        IntegrationImplementation.PreOverallSequencingProcess();
    }

    //
    // Note that upon exit the OverallSequencingProcess will result in an ExitScormPlayer call which
    // will do the final data postback
    //
    this.Sequencer.OverallSequencingProcess();

    //
    // don't bother with look ahead  or saving if we're exiting. it slows things down and introduces funny
    // sequencing situations that lead to errors and the save is redundant since we'll do SaveDataOnExit
    //
    if (this.ExitScormPlayerCalled === false && ! this.DeliverFramesetUnloadEventCalled) {
        this.EvaluatePossibleNavigationRequests();

        // We need to interject this SaveData call and reset the timer
        this.Comm.KillPostDataProcess();
        this.Comm.SaveData(true, false);
        this.Comm.StartPostDataProcess();
    }
}

//
// This method is only called directly by the OverallSequencingProcess.  There's one way this would get called twice (and therefore save data twice): if
// there's a straggling APIFinish call made after Unload() has run.
//
function Controller_ExitScormPlayer () {
    // TODO: should this be an integration function?
    // TODO: can we always count on the current window being the player window?

    this.ExitScormPlayerCalled = true;

    if (Debug.ShowDebugLogAtExit) {
        if (Debug.DataIsAvailable()) {
            Debug.ShowAllAvailableData();
        }
    }

    this.Comm.SaveDataOnExit();

    $("html").trigger(new jQuery.Event("_playerExit"));

    // Calling this after save data call to capture any potential problems during the communcations postback
    if (this.ShouldSaveClientDebugLogs && rscpCfg.get("registrationToDeliver").TrackingEnabled) {
        this.Comm.SaveDebugLog(true);
    }

    // This window manipulation might be redundant and mess the the firing of events if done
    // when the player is already unloading
    if (! this.ProcessedUnload) {
        if (this.Package.Properties.PlayerLaunchType === LAUNCH_TYPE_FRAMESET) {
            // Protect against case where the top level window is killed/closed.
            try {
                Control.HandleRedirectIfRequired(window);
            }
            catch (e) {
                // Eat it, must have been hard-closed
            }
        }
        else if (! this.PopupBlocked) {
            // Protect against case where the top level window is killed/closed.
            try {
                if (window.opener && window.opener !== null && window.opener.closed === false) {
                    Control.HandleRedirectIfRequired(window.opener);
                }
            }
            catch (e) {
                // Eat it, must have been hard-closed
            }

            try {
                window.close();
            }
            catch (e) {
                // Eat it, must have been hard-closed
            }
        }
    }
}

function Controller_ExitSco () {
    this.ScoLoader.UnloadSco();
}

function Controller_MarkPostedDataDirty () {
    var activity,
        globalObjective,
        dataState,
        bucket;

    this.WriteAuditLog("Control MarkPostedDataDirty");

    for (activity in this.Activities.ActivityList) {
        if (this.Activities.ActivityList.hasOwnProperty(activity)) {
            if (this.Activities.ActivityList[activity].DataState === DATA_STATE_POSTED) {
                this.Activities.ActivityList[activity].DataState = DATA_STATE_DIRTY;
            }

            this.Activities.ActivityList[activity].MarkPostedObjectiveDataDirty();
        }
    }

    if (typeof this.Sequencer.GlobalObjectives !== "undefined" && this.Sequencer.GlobalObjectives !== null) {
        for (globalObjective in this.Sequencer.GlobalObjectives) {
            if (this.Sequencer.GlobalObjectives.hasOwnProperty(globalObjective)) {
                dataState = this.Sequencer.GlobalObjectives[globalObjective].DataState;

                if (dataState === DATA_STATE_POSTED) {
                    this.Sequencer.GlobalObjectives[globalObjective].DataState = DATA_STATE_DIRTY;
                }
            }
        }
    }

    for (bucket in this.SSPBuckets) {
        if (this.SSPBuckets.hasOwnProperty(bucket)) {
            if (this.SSPBuckets[bucket].DataState === DATA_STATE_POSTED) {
                this.SSPBuckets[bucket].DataState = DATA_STATE_DIRTY;
            }
        }
    }
}

function Controller_MarkPostedDataClean () {
    var activity,
        globalObjective,
        dataState,
        bucket;

    this.WriteAuditLog("Control MarkPostedDataClean");

    for (activity in this.Activities.ActivityList) {
        if (this.Activities.ActivityList.hasOwnProperty(activity)) {
            if (this.Activities.ActivityList[activity].DataState === DATA_STATE_POSTED) {
                this.Activities.ActivityList[activity].DataState = DATA_STATE_CLEAN;
            }

            this.Activities.ActivityList[activity].MarkPostedObjectiveDataClean();
        }
    }

    if (typeof this.Sequencer.GlobalObjectives !== "undefined" && this.Sequencer.GlobalObjectives !== null) {
        for (globalObjective in this.Sequencer.GlobalObjectives) {
            if (this.Sequencer.GlobalObjectives.hasOwnProperty(globalObjective)) {
                dataState = this.Sequencer.GlobalObjectives[globalObjective].DataState;

                if (dataState === DATA_STATE_POSTED) {
                    this.Sequencer.GlobalObjectives[globalObjective].DataState = DATA_STATE_CLEAN;
                }
            }
        }
    }

    for (bucket in this.SSPBuckets) {
        if (this.SSPBuckets.hasOwnProperty(bucket)) {
            if (this.SSPBuckets[bucket].DataState === DATA_STATE_POSTED) {
                this.SSPBuckets[bucket].DataState = DATA_STATE_CLEAN;
            }
        }
    }
}

function Controller_MarkDirtyDataPosted () {
    var activity,
        globalObjective,
        dataState,
        bucket;

    this.WriteAuditLog("Control MarkDirtyDataPosted");

    for (activity in this.Activities.ActivityList) {
        if (this.Activities.ActivityList.hasOwnProperty(activity)) {
            if (this.Activities.ActivityList[activity].IsAnythingDirty()) {
                this.Activities.ActivityList[activity].DataState = DATA_STATE_POSTED;
            }

            this.Activities.ActivityList[activity].MarkDirtyObjectiveDataPosted();
        }
    }

    if (typeof this.Sequencer.GlobalObjectives !== "undefined" && this.Sequencer.GlobalObjectives !== null) {
        for (globalObjective in this.Sequencer.GlobalObjectives) {
            if (this.Sequencer.GlobalObjectives.hasOwnProperty(globalObjective)) {
                dataState = this.Sequencer.GlobalObjectives[globalObjective].DataState;

                if (dataState === DATA_STATE_DIRTY) {
                    this.Sequencer.GlobalObjectives[globalObjective].DataState = DATA_STATE_POSTED;
                }
            }
        }
    }

    for (bucket in this.SSPBuckets) {
        if (this.SSPBuckets.hasOwnProperty(bucket)) {
            if (this.SSPBuckets[bucket].DataState === DATA_STATE_DIRTY) {
                this.SSPBuckets[bucket].DataState = DATA_STATE_POSTED;
            }
        }
    }
}

function Controller_PrepareResultsPayload (payload) {
    if (rscpCfg.get("compressRecordResultsPayload") === true) {
        return this.CompressionIndicatorToken + LZString.compressToBase64(payload);
    }

    return payload;
}

function Controller_UpdateLastState (postedData) {
    this.LastState = GetUpdatedLastState(this.LastState, postedData, this.CompressionIndicatorToken);
}

function Controller_GetDeltaXmlForDirtyData (xmlRequestPayload) {
    var runtimeAttributes = {},
        registrationToDeliver = rscpCfg.get("registrationToDeliver");

    if (this.LastState === null) {
        // We currently don't have anything set for the 'LastState'. This happens when we are sending the first
        // 'RecordResults' request. Send the whole XML string. Since this payload won't be a 'delta' that needs
        // to be merged with existing registration data, don't add the "DETLA" attribute to the RTD.
        return xmlRequestPayload;
    }

    // We need to add in the essential, top-level attributes so that we can pull the rest of the registration and
    // runtime data on the server. The "DELTA" attribute is what indicates a delta payload on the server side.
    runtimeAttributes.DELTA = "true";
    runtimeAttributes.RI = registrationToDeliver.Id;
    runtimeAttributes.TR = registrationToDeliver.TrackingEnabled;
    if (this.Sequencer.GetSuspendedActivity() !== null) {
        runtimeAttributes.SAI = this.Sequencer.GetSuspendedActivity().GetDatabaseIdentifier();
    }

    if (this.GetLaunchHistoryId() !== null) {
        runtimeAttributes.LH = this.GetLaunchHistoryId();
    }

    return BuildXmlForDirtyData(this.LastState, xmlRequestPayload, runtimeAttributes, XmlElement.EncodeExceptQuote);
}

// eslint-disable-next-line complexity
function Controller_GetXmlForDirtyData (isGatheringInitialState) {
    var ServerFormat = new ServerFormater(),
        xml = new XmlElement("RTD"),
        registrationToDeliver = rscpCfg.get("registrationToDeliver"),
        activity,
        globalObjective,
        dataState,
        bucket,
        sharedDataItem,
        historyLogXml,
        rootActivity,
        xmlStatus,
        satisfactionStatus,
        completionStatus,
        emptyHistoryLogString,
        xmlString;

    this.WriteAuditLog("Control GetXmlForDirtyData");

    xml.AddAttribute("RI", registrationToDeliver.Id);

    if (this.Sequencer.GetSuspendedActivity() !== null) {
        xml.AddAttribute("SAI", this.Sequencer.GetSuspendedActivity().GetDatabaseIdentifier());
    }

    if (this.GetLaunchHistoryId() !== null) {
        xml.AddAttribute("LH", this.GetLaunchHistoryId());
    }

    xml.AddAttribute("TR", registrationToDeliver.TrackingEnabled);

    //
    // We're still going to postback when tracking is disabled but we don't want/need the extra
    // reg data appended that's not going to be persisted.
    //
    if (registrationToDeliver.TrackingEnabled) {
        for (activity in this.Activities.ActivityList) {
            if (this.Activities.ActivityList.hasOwnProperty(activity)) {
                if (isGatheringInitialState || this.Activities.ActivityList[activity].IsAnythingDirty() || this.Activities.ActivityList[activity].DataState === DATA_STATE_POSTED) {
                    xml.AddElement(this.Activities.ActivityList[activity].GetXml());
                }
            }
        }
    }
    if (registrationToDeliver.TrackingEnabled && ! isGatheringInitialState) {
        if (typeof this.Sequencer.GlobalObjectives !== "undefined" && this.Sequencer.GlobalObjectives !== null) {
            for (globalObjective in this.Sequencer.GlobalObjectives) {
                if (this.Sequencer.GlobalObjectives.hasOwnProperty(globalObjective)) {
                    dataState = this.Sequencer.GlobalObjectives[globalObjective].DataState;

                    // for now we're posting all global objectives
                    // eslint-disable-next-line max-depth
                    if (dataState === DATA_STATE_DIRTY || dataState === DATA_STATE_POSTED) {
                        xml.AddElement(this.Sequencer.GlobalObjectives[globalObjective].GetXml(registrationToDeliver.Id, globalObjective));
                    }
                }
            }
        }

        for (bucket in this.SSPBuckets) {
            if (this.SSPBuckets.hasOwnProperty(bucket)) {
                if (this.SSPBuckets[bucket].DataState === DATA_STATE_DIRTY || this.SSPBuckets[bucket].DataState === DATA_STATE_POSTED) {
                    xml.AddElement(this.SSPBuckets[bucket].GetXml());
                }
            }
        }

        for (sharedDataItem in this.SharedData) {
            if (this.SharedData.hasOwnProperty(sharedDataItem)) {
                if (this.SharedData[sharedDataItem].DataState === DATA_STATE_DIRTY || this.SharedData[sharedDataItem].DataState === DATA_STATE_POSTED) {
                    xml.AddElement(this.SharedData[sharedDataItem].GetXml());
                }
            }
        }
    }

    // Append the current event log for this launch
    // Try to add the history log, if something breaks make a note of it in the XML...
    emptyHistoryLogString = "<RTL version=\"\" />";
    if (isGatheringInitialState) {
        xml.AddElement(emptyHistoryLogString);
    }
    else {
        try {
            historyLogXml = HistoryLog.GetSerializedLog();
            historyLogXml.AddAttribute("trackingEnabled", registrationToDeliver.TrackingEnabled.toString());

            xml.AddElement(historyLogXml);
        }
        catch (error) {
            xml.AddElement(emptyHistoryLogString);
            xml.AddElement("<RTL_ERROR>There was an error attaching the history log to this XML, see Controller_GetXmlForDirtyData (" + error + ")</RTL_ERROR>");
        }
    }
    // Append overall registration status
    rootActivity = this.Activities.GetRootActivity();
    xmlStatus = new XmlElement("RS");

    // Satisfaction - pass/fail/unknown
    if (rootActivity.GetPrimaryObjective().ProgressStatus) {
        satisfactionStatus = rootActivity.GetPrimaryObjective().SatisfiedStatus ? "passed" : "failed";
    }
    else {
        satisfactionStatus = "unknown";
    }
    xmlStatus.AddAttribute("SS", satisfactionStatus);

    // Completion - complete/incomplete/unknown
    if (rootActivity.AttemptProgressStatus) {
        completionStatus = rootActivity.AttemptCompletionStatus ? "complete" : "incomplete";
    }
    else {
        completionStatus = "unknown";
    }
    xmlStatus.AddAttribute("CS", completionStatus);

    xmlStatus.AddAttribute("MS", ServerFormat.ConvertBoolean(rootActivity.GetPrimaryObjective().MeasureStatus));
    xmlStatus.AddAttribute("NM", rootActivity.GetPrimaryObjective().NormalizedMeasure);
    xmlStatus.AddAttribute("ED", ServerFormat.ConvertTimeSpan(rootActivity.ActivityExperiencedDurationTracked));

    xml.AddElement(xmlStatus);
    xmlString = xml.toString();

    if (rscpCfg.get("useDeltaRecordResultsPayload") === true) {
        xmlString = this.GetDeltaXmlForDirtyData(xmlString);
    }

    return this.PrepareResultsPayload("<?xml version=\"1.0\"?>\n" + xmlString);
}

function Controller_IsThereDirtyData () {
    var activity,
        globalObjective,
        dataState,
        bucket;

    this.WriteAuditLog("Control IsThereDirtyData");

    for (activity in this.Activities.ActivityList) {
        if (this.Activities.ActivityList.hasOwnProperty(activity)) {
            if (this.Activities.ActivityList[activity].IsAnythingDirty() || this.Activities.ActivityList[activity].DataState === DATA_STATE_POSTED) {
                return true;
            }
        }
    }

    if (typeof this.Sequencer.GlobalObjectives !== "undefined" && this.Sequencer.GlobalObjectives !== null) {
        for (globalObjective in this.Sequencer.GlobalObjectives) {
            if (this.Sequencer.GlobalObjectives.hasOwnProperty(globalObjective)) {
                dataState = this.Sequencer.GlobalObjectives[globalObjective].DataState;

                if (dataState === DATA_STATE_DIRTY || dataState === DATA_STATE_POSTED) {
                    return true;
                }
            }
        }
    }

    for (bucket in this.SSPBuckets) {
        if (this.SSPBuckets.hasOwnProperty(bucket)) {
            if (this.SSPBuckets[bucket].DataState === DATA_STATE_DIRTY || this.SSPBuckets[bucket].DataState === DATA_STATE_POSTED) {
                return true;
            }
        }
    }

    return false;
}

//
// isTerminating currently does nothing, but is being passed in because we may want
// to force a postback for Terminate() even if scormImmediateSyncCommit is not on.
// Not doing so now due to the amount of testing that would be required.
//
function Controller_DoCommit (isTerminating, completionNotSaved) {
    var immediateSyncCommit = rscpCfg.get("scormImmediateSyncCommit");

    if (immediateSyncCommit === true || (completionNotSaved && ! this.DeliverFramesetUnloadEventCalled)) {
        return this.Comm.SaveDataNow(false, immediateSyncCommit);
    }

    // if not doing an immediate synchronous commit, just report success
    // (we will save the data to the server later)
    return true;
}

function Controller_DisplayError (errorString) {
    var message,
        debugOffer;

    this.WriteAuditLog("Control DisplayError - " + errorString);

    message = IntegrationImplementation.GetString(errorString);
    if (Debug.DataIsAvailable() && rscpCfg.get("clientDebuggerEnabled")) {
        debugOffer = IntegrationImplementation.GetString("Press 'OK' to display debug information to send to technical support, or press 'Cancel' to exit.");

        // eslint-disable-next-line no-alert
        if (confirm(message + "\n\n" + debugOffer)) {
            Debug.ShowAllAvailableData();
        }
    }
    else if (this.Package.Properties.ScoLaunchType === "new window") {
        try {
            // eslint-disable-next-line no-alert
            this.ScoLoader.ContentFrame.scoWindow.alert(message);
        }
        catch (e) {
            // eslint-disable-next-line no-alert
            alert(message);
        }
    }
    else {
        // eslint-disable-next-line no-alert
        alert(message);
    }
}

function Controller_GetExceptionText () {
    //
    // Exit timing somestimes has us writing to the debugger when it's already gone.
    // Code is called by the intermediate page.
    //
    if (typeof Debug !== "undefined") {
        this.WriteAuditLog("Control GetExceptionText");
    }

    //
    // should return human readable error message from the sequencer.
    // this is called from the intermediate page if it is stuck there
    //
    // there are certain timing situations where this method will get invoked
    // before the page has completed loading while the sequencer is still null
    //
    if (typeof this.Sequencer !== "undefined" && this.Sequencer !== null) {
        return this.Sequencer.GetExceptionText();
    }

    return "";
}

//
// This method ensures the debug command still works with skinnable defaultui pages,
// which use the old debug code, this just passes the command to the commandsentry
// in the top level window
//
function Controller_CheckForDebugCommand (intKeyCode) {
    window.top.DebugCommandSentry.enterKeyCode(intKeyCode);
}

function Controller_CloseSco () {
    this.WriteAuditLog("Control Recieved Close Sco From GUI");

    if (this.PendingNavigationRequest === null) {
        if (this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_EXIT].WillSucceed === true) {
            this.PendingNavigationRequest = new NavigationRequest(NAVIGATION_REQUEST_EXIT, null, "");
        }
        else if (this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_ABANDON] === true) {
            this.PendingNavigationRequest = new NavigationRequest(NAVIGATION_REQUEST_ABANDON, null, "");
        }
    }

    this.WriteHistoryLog(
        "",
        {
            ev: "GUI Close",
            ac: this.PendingNavigationRequest.Type
        }
    );

    // TODO: in SCORM 2004 and 1.2, we need to provide a message to the user

    this.ScoLoader.UnloadSco();
}

//
// Legacy UI's can call this method without the preferred action defined.  New
// SCORM 2004 4TH ed capable UI's should explicitly pass an action of "suspend_all"
// or "exit_all" to this method. The UI might choose to do this through a dialog
// or two explicit buttons
//
function Controller_ReturnToLms (preferredAction) {
    this.WriteAuditLog("Control Received Return To Lms From GUI");

    this.Sequencer.ReturnToLmsInvoked = true;

    if (typeof preferredAction === "undefined" || preferredAction === null) {
        preferredAction = this.GetPreferredReturnToLmsAction();
    }

    if (this.PendingNavigationRequest === null) {
        this.PendingNavigationRequest = this.GetReturnToLmsNavigationRequest(preferredAction);
    }

    this.WriteHistoryLog(
        "",
        {
            ev: "GUI ReturnToLms",
            ac: this.PendingNavigationRequest.Type
        }
    );

    this.ScoLoader.UnloadSco();
}

function Controller_GetReturnToLmsNavigationRequest (preferredAction) {
    //
    // The whole point of a suspend all is to get the user back to where he last left off.
    // If we have a single sco, then this isn't necessary. It is probably better in this
    // case to process an Exit All because that will call End Attempt and transfer the
    // runtime data to the activity tree for rollup.
    //
    var hideSuspendAll = false,
        hideAbandonAll = false,
        hideExitAll = false,
        allUIHidden = false;

    if (this.Sequencer.CurrentActivity !== null) {
        hideSuspendAll = this.Sequencer.CurrentActivity.LearningObject.SequencingData.HideSuspendAll;
        hideAbandonAll = this.Sequencer.CurrentActivity.LearningObject.SequencingData.HideAbandonAll;
        hideExitAll = this.Sequencer.CurrentActivity.LearningObject.SequencingData.HideExitAll;
    }

    allUIHidden = hideAbandonAll && hideExitAll && hideSuspendAll;

    if (this.Activities.GetNumDeliverableActivities() === 1) {
        if (hideExitAll === false && this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_EXIT_ALL].WillSucceed === true) {
            return new NavigationRequest(NAVIGATION_REQUEST_EXIT_ALL, null, "");
        }
        else if (hideSuspendAll === false && this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_SUSPEND_ALL].WillSucceed === true) {
            return new NavigationRequest(NAVIGATION_REQUEST_SUSPEND_ALL, null, "");
        }
    }
    else {
        // If allIsUIHidden = true, then we allow the preferredAction to pass through
        // rather than rejecting it as we would if only that action had been hidden.
        // See JIRA Ticket SE-1345
        // eslint-disable-next-line no-lonely-if
        if (preferredAction === "exit_all") {
            if ((hideExitAll === false || allUIHidden) && this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_EXIT_ALL].WillSucceed === true) {
                return new NavigationRequest(NAVIGATION_REQUEST_EXIT_ALL, null, "");
            }
        }
        else if (preferredAction === "suspend_all") {
            /* MR - 8/31/09 - removing this, wrong implementation of this package property. moved to the
             * TerminationRequestProcess in the SuspendAll case
               if (Control.Package.Properties.InvokeRollupAtSuspendAll === true) {
                    window.setTimeout("Control.EvaluatePossibleNavigationRequests(true);", 150);
                }
            */
            if ((hideSuspendAll === false || allUIHidden) && this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_SUSPEND_ALL].WillSucceed === true) {
                return new NavigationRequest(NAVIGATION_REQUEST_SUSPEND_ALL, null, "");
            }
        }
    }

    // if neither suspend nor exit will succeed, try to abandon or just simply exit
    if (hideAbandonAll === false && this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_ABANDON_ALL].WillSucceed === true) {
        return new NavigationRequest(NAVIGATION_REQUEST_ABANDON_ALL, null, "");
    }

    return new NavigationRequest(NAVIGATION_REQUEST_EXIT_PLAYER, null, "");
}

function Controller_ToggleMenuVisibility () {
    this.WriteAuditLog("Control ToggleMenuVisibility");

    if (this.MenuIsVisible === true) {
        IntegrationImplementation.HideMenu();
        this.MenuIsVisible = false;
    }
    else {
        IntegrationImplementation.ShowMenu(this.Package.Properties.CourseStructureWidth);
        this.MenuIsVisible = true;
    }
}

function Controller_HideExitDialog () {
    IntegrationImplementation.HideExitDialog();
    this.ExitDialogVisible = false;
}

function Controller_TriggerReturnToLMS () {
    var hideSuspendAll = false,
        hideExitAll = false,
        hideAbandonAll = false,
        logParent = this.WriteAuditLog("Control TriggerReturnToLMS");

    if (this.Sequencer.CurrentActivity !== null) {
        hideSuspendAll = this.Sequencer.CurrentActivity.LearningObject.SequencingData.HideSuspendAll;
        hideExitAll = this.Sequencer.CurrentActivity.LearningObject.SequencingData.HideExitAll;
        hideAbandonAll = this.Sequencer.CurrentActivity.LearningObject.SequencingData.HideAbandonAll;
    }

    // Let the current activity's choice override package properties defaults
    if (hideSuspendAll === true || hideExitAll === true) {
        if (hideSuspendAll === true) {
            if (hideExitAll === true) {
                if (hideAbandonAll === true) {
                    this.WriteDetailedLog("The Return To LMS button should not be available for selection.", logParent);
                }
                else {
                    this.ReturnToLms("abandon_all");
                }
            }
            else {
                this.ReturnToLms("exit_all");
            }
        }
        else {
            this.ReturnToLms("suspend_all");
        }
    }
    else if (! this.Package.LearningStandard.is2004()) {
        // Only SCORM 2004 can have non-legacy setting for ReturnToLMS
        if (this.Package.Properties.ReturnToLmsAction !== "legacy") {
            this.WriteDetailedLogError("Package had non-legacy setting for ReturnToLMS, but does not use SCORM 2004");
        }
        this.TriggerLegacyReturnToLMS();
    }
    else if (this.Package.Properties.ReturnToLmsAction === "selectable") {
        if (this.ExitDialogVisible === false) {
            this.ExitDialogVisible = true;
            IntegrationImplementation.ShowExitDialog();
        }
    }
    else if (this.Package.Properties.ReturnToLmsAction === "legacy") {
        this.TriggerLegacyReturnToLMS();
    }
    else {
        this.ReturnToLms(this.Package.Properties.ReturnToLmsAction);
    }
}

function Controller_TriggerLegacyReturnToLMS () {
    if (this.Activities.GetNumDeliverableActivities() === 1) {
        this.ReturnToLms("exit_all");
    }
    else {
        this.ReturnToLms("suspend_all");
    }
}

function Controller_Next () {
    this.WriteAuditLog("Control Recieved Next Request From GUI");
    this.WriteHistoryLog("", {ev: "GUI Continue"});

    if (this.PendingNavigationRequest === null) {
        this.PendingNavigationRequest = new NavigationRequest(NAVIGATION_REQUEST_CONTINUE, null);
    }

    this.ScoLoader.UnloadSco();
}

function Controller_Previous () {
    this.WriteAuditLog("Control Recieved Previous Request From GUI");
    this.WriteHistoryLog("", {ev: "GUI Previous"});

    if (this.PendingNavigationRequest === null) {
        this.PendingNavigationRequest = new NavigationRequest(NAVIGATION_REQUEST_PREVIOUS, null, "");
    }

    this.ScoLoader.UnloadSco();
}

function Controller_Abandon () {
    this.WriteAuditLog("Control Recieved Abandon Request From GUI");
    this.WriteHistoryLog("", {ev: "GUI Abandon"});

    if (this.PendingNavigationRequest === null) {
        this.PendingNavigationRequest = new NavigationRequest(NAVIGATION_REQUEST_ABANDON, null, "");
    }

    this.ScoLoader.UnloadSco();
}

function Controller_AbandonAll () {
    this.WriteAuditLog("Control Recieved Abandon All Request From GUI");
    this.WriteHistoryLog("", {ev: "GUI AbandonAll"});

    if (this.PendingNavigationRequest === null) {
        this.PendingNavigationRequest = new NavigationRequest(NAVIGATION_REQUEST_ABANDON_ALL, null, "");
    }

    this.ScoLoader.UnloadSco();
}

function Controller_Suspend () {
    this.WriteAuditLog("Control Recieved Suspend Request From GUI");
    this.WriteHistoryLog("", {ev: "GUI Suspend"});

    if (this.PendingNavigationRequest === null) {
        this.PendingNavigationRequest = new NavigationRequest(NAVIGATION_REQUEST_SUSPEND_ALL, null, "");
    }

    this.ScoLoader.UnloadSco();
}

function Controller_Exit () {
    this.WriteAuditLog("Control Recieved Exit Request From GUI");
    this.WriteHistoryLog("", {ev: "GUI Exit"});

    if (this.PendingNavigationRequest === null) {
        this.PendingNavigationRequest = new NavigationRequest(NAVIGATION_REQUEST_EXIT, null, "");
    }

    // TODO: in SCORM 2004 and 1.2, we need to provide a message to the user

    this.ScoLoader.UnloadSco();
}

function Controller_ExitAll () {
    this.WriteAuditLog("Control Recieved Exit All Request From GUI");
    this.WriteHistoryLog("", {ev: "GUI ExitAll"});

    if (this.PendingNavigationRequest === null) {
        this.PendingNavigationRequest = new NavigationRequest(NAVIGATION_REQUEST_EXIT_ALL, null, "");
    }

    this.ScoLoader.UnloadSco();
}

function Controller_ChoiceRequest (activityItemIdentifier) {
    var historyAtts = {ev: "GUI Choice"},
        activity = null;

    this.WriteAuditLog("Control Recieved Choice Request For '" + activityItemIdentifier + "' From GUI");

    if (this.Activities) {
        activity = this.Activities.GetActivityFromIdentifier(activityItemIdentifier);

        if (activity) {
            historyAtts.tai = activity.ItemIdentifier;
            historyAtts.tat = activity.LearningObject.Title;
        }
    }
    this.WriteHistoryLog("", historyAtts);

    if (this.PendingNavigationRequest === null) {
        this.PendingNavigationRequest = new NavigationRequest(NAVIGATION_REQUEST_CHOICE, activityItemIdentifier, "");
    }

    this.ScoLoader.UnloadSco();
}

function Controller_ScoHasTerminatedSoUnload () {
    this.WriteAuditLog("In ScoHasTerminatedSoUnload");

    this.ScoLoader.UnloadSco();
}

//
// This is method is simply just the Generic Finish/Terminate behavior that the Controller
// must do, regardless of the learning standard. It is called at the end of each API's
// Finish or Terminate call.
//
function Controller_SignalTerminated () {
    var runtime = this.Api.RunTimeData,
        unloadingOrNavRequest = false;

    //
    // This condition should only be seen when the Unload() method (Called by the deliver
    // frameset's onunload) has already been called and done its thing, including SaveDataOnExit,
    // but a Straggling Api.Finish() or Termiate() call had been made by the content's window
    // unload event handlers. Note that Unload() would have returned the state back to
    // pre-overallsequencingprocess so it's safe to run it over again here.
    //
    // if (this.ProcessedUnload === true && this.ExitScormPlayerCalled === false) {
    if (this.DeliverFramesetUnloadEventCalled) {
        unloadingOrNavRequest = true;

        if (this.ScoLoader.ScoLoaded) {
            //
            // if the browser unload event has been fired and the window is closing because
            // the user closed the browser window (and not as a result of a sequencing action
            // which would be indicated by ExitScormPlayerCalled == true) then we need to
            // transfer the runtime data to the activity tree and rollup the data before saving
            // and closing this will be handled by running the OverallSequencingProcess
            //
            // Since Unload has been processed it means we'ere tearing down windows now. So set
            // the return to lms nav request in a legacy manner that prevents any user-selectable
            // alerts which could short circuit processing of the overall sequencer we're trying
            // to get to.
            //
            if (this.Activities.GetNumDeliverableActivities() === 1) {
                this.PendingNavigationRequest = this.GetReturnToLmsNavigationRequest("exit_all");
            }
            else {
                this.PendingNavigationRequest = this.GetReturnToLmsNavigationRequest("suspend_all");
            }

            this.ScoUnloaded("SignalTerminated()");

            if (! this.ExitScormPlayerCalled) {
                //
                // Some sequencing paths such as simply "close item" will not have resulted
                // in ExitScormPlayer
                //
                this.ExitScormPlayer("SignalTerminated()");
            }
        }
        else {
            //
            // We must be in the middle of an Unload with a Finish that happened in the interim --
            // rare thing that I noticed happening when the middle window was closed from launch
            // player in new window / launch sco in new window
            //
            this.SignalTerminatedPending = true;
        }
    }

    if (this.PendingNavigationRequest || (runtime && runtime.NavRequest !== SCORM_RUNTIME_NAV_REQUEST_NONE)) {
        // terminating with a nav request
        unloadingOrNavRequest = true;
    }

    if (! unloadingOrNavRequest && rscpCfg.get("rollupOnTerminate") === true && typeof this.Sequencer.TriggerRollup === "function") {
        // Terminating with no nav requst and "rollupOnTerminate" set. Rollup will not be triggered so if the
        // learning standard exposes rollup then trigger it now. This way the rolled up status is up to date as soon as
        // possible to mitigate lost final postbacks
        //
        // Note: TriggerRollup calls "end attempt", which maps runtime data to the activity model and then calls rollup.
        // Since end attempt is called in "suspend all" mode, the attempt is not actually ended.
        this.Sequencer.TriggerRollup("Controller SignalTerminated, 'rollupOnTerminate' set and no navigation request.");
    }
}

function Controller_GetPreferredReturnToLmsAction () {
    var action = "";

    if (this.Package.Properties.ReturnToLmsAction === "selectable") {
        // TODO: translate
        // eslint-disable-next-line no-alert
        if (confirm("Exiting Course. Click 'OK' To save state and pick up where you left off or choose 'Cancel' to finish the Course.")) {
            action = "suspend_all";
        }
        else {
            action = "exit_all";
        }
    }
    else if (this.Package.Properties.ReturnToLmsAction === "legacy") {
        if (this.Activities.GetNumDeliverableActivities() === 1) {
            action = "exit_all";
        }
        else {
            action = "suspend_all";
        }
    }
    else {
        action = this.Package.Properties.ReturnToLmsAction;
    }

    return action;
}

function Controller_TranslateRunTimeNavRequest (adlNavRequest) {
    var targetIdentifier;

    //
    // accepts an adl.nav.request from the RTE and translates it into an internal NavigationRequest object
    //
    if (adlNavRequest.substring(0, 1) === "{") {
        targetIdentifier = this.ParseTargetStringFromChoiceRequest(adlNavRequest);

        if (adlNavRequest.substr(adlNavRequest.indexOf("}") + 1) === "choice") {
            return new NavigationRequest(NAVIGATION_REQUEST_CHOICE, targetIdentifier, "");
        }
        else if (adlNavRequest.substr(adlNavRequest.indexOf("}") + 1) === "jump") {
            return new NavigationRequest(NAVIGATION_REQUEST_JUMP, targetIdentifier, "");
        }
    }

    switch (adlNavRequest) {
        case SCORM_RUNTIME_NAV_REQUEST_CONTINUE:
            return new NavigationRequest(NAVIGATION_REQUEST_CONTINUE, null, "");
        case SCORM_RUNTIME_NAV_REQUEST_PREVIOUS:
            return new NavigationRequest(NAVIGATION_REQUEST_PREVIOUS, null, "");
        case SCORM_RUNTIME_NAV_REQUEST_EXIT:
            return new NavigationRequest(NAVIGATION_REQUEST_EXIT, null, "");
        case SCORM_RUNTIME_NAV_REQUEST_EXITALL:
            return new NavigationRequest(NAVIGATION_REQUEST_EXIT_ALL, null, "");
        case SCORM_RUNTIME_NAV_REQUEST_ABANDON:
            return new NavigationRequest(NAVIGATION_REQUEST_ABANDON, null, "");
        case SCORM_RUNTIME_NAV_REQUEST_ABANDONALL:
            return new NavigationRequest(NAVIGATION_REQUEST_ABANDON_ALL, null, "");
        case SCORM_RUNTIME_NAV_REQUEST_SUSPENDALL:
            return new NavigationRequest(NAVIGATION_REQUEST_SUSPEND_ALL, null, "");
        case SCORM_RUNTIME_NAV_REQUEST_NONE:
            return null;
        default:
            Debug.AssertError("Unrecognized runtime navigation request");
            break;
    }

    return null;
}

function Controller_FindPossibleNavRequestForRuntimeNavRequest (adlNavRequest) {
    var targetIdentifier,
        arrayIndex,
        i,
        jumpRequest;

    //
    // accepts an adl.nav.request from the RTE and finds the associated internal PossibleNavigationRequest object if it exists
    //
    if (adlNavRequest.substring(0, 1) === "{") {
        targetIdentifier = this.ParseTargetStringFromChoiceRequest(adlNavRequest);

        if (adlNavRequest.substr(adlNavRequest.indexOf("}") + 1) === "choice") {
            arrayIndex = POSSIBLE_NAVIGATION_REQUEST_INDEX_CHOICE;

            for (i = arrayIndex; i < this.PossibleNavigationRequests.length; i += 1) {
                if (this.PossibleNavigationRequests[i].TargetActivityItemIdentifier === targetIdentifier) {
                    return this.PossibleNavigationRequests[i];
                }
            }
        }
        else if (adlNavRequest.substr(adlNavRequest.indexOf("}") + 1) === "jump") {
            jumpRequest = new NavigationRequest(NAVIGATION_REQUEST_JUMP, targetIdentifier, "");
            jumpRequest.WillSucceed = this.IsJumpRequestValid(adlNavRequest);

            return jumpRequest;
        }
    }

    switch (adlNavRequest) {
        case SCORM_RUNTIME_NAV_REQUEST_CONTINUE:
            return this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_CONTINUE];
        case SCORM_RUNTIME_NAV_REQUEST_PREVIOUS:
            return this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_PREVIOUS];
        case SCORM_RUNTIME_NAV_REQUEST_EXIT:
            return this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_EXIT];
        case SCORM_RUNTIME_NAV_REQUEST_EXITALL:
            return this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_EXIT_ALL];
        case SCORM_RUNTIME_NAV_REQUEST_ABANDON:
            return this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_ABANDON];
        case SCORM_RUNTIME_NAV_REQUEST_ABANDONALL:
            return this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_ABANDON_ALL];
        case SCORM_RUNTIME_NAV_REQUEST_SUSPENDALL:
            return this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_SUSPEND_ALL];
        case SCORM_RUNTIME_NAV_REQUEST_NONE:
            return null;
        default:
            Debug.AssertError("Unrecognized runtime navigation request");
            break;
    }

    return null;
}

function Controller_HandleRedirectIfRequired (theWindow) {
    var RedirectOnExitUrl = rscpCfg.get("redirectOnExitUrl");

    //
    // If the redirect is equal to 'noop' or starts with 'noop_message' then don't redirect.
    // If the redirect starts with 'javascript:', then don't redirect. This will avoid XSS.
    // Additionally, the browser doesn't care about the case of 'javascript:', so using toLowerCase()
    // on RedirectOnExitUrl. ' javascript:' (left padding) will also execute, so using trim().
    // If an attempt is made to send in 'javascript:', the exit behaves as a 'noop'.
    //

    // eslint-disable-next-line no-script-url
    if (RedirectOnExitUrl !== "noop" && RedirectOnExitUrl.indexOf("noop_message=") !== 0 && RedirectOnExitUrl.trim().toLowerCase().indexOf("javascript:") !== 0) {
        theWindow.location = RedirectOnExitUrl;
    }
    //
    // if the redirect is a noop with a custom message, then extract that message and have
    // it displayed by intermediate page. We can't use startsWith here as only supported
    // by IE12+. WTH IE?!
    //
    else if (RedirectOnExitUrl.indexOf("noop_message=") === 0) {
        //
        // we set the NoOp redirect message here. It will be picked up by GetMessageText
        // if appropriate and displayed to the user.
        //
        this.NoOpRedirectMsg = RedirectOnExitUrl.substring(RedirectOnExitUrl.indexOf("=") + 1);
    }

    // otherwise do nothing. User will be left on intermediate page with default message.
}

function Controller_GetMessageText () {
    var msg = "";

    try {
        if (typeof this.Sequencer.NavigationRequest !== "undefined" && this.Sequencer.NavigationRequest !== null) {
            if (typeof this.Sequencer.NavigationRequest.MessageToUser !== "undefined" && this.Sequencer.NavigationRequest.MessageToUser !== null) {
                msg = this.Sequencer.NavigationRequest.MessageToUser;
            }
        }
    }
    catch (e) {
        // Return "" by default, timing errors have caused problems here despite our checks for null and undefined
    }

    //
    // SE-1503. If we have noop redirect URL we might not want to display the default "Loading. Please wait..." message
    // as we aren't actually waiting for anything. If a message has been configured we'll show it instead.
    //
    if (this.ExitScormPlayerCalled && msg === "" && rscpCfg.get("redirectOnExitUrl").indexOf("noop_message=") === 0 && this.NoOpRedirectMsg !== "") {
        msg = this.NoOpRedirectMsg;
    }

    return msg;
}

function Controller_ClearPendingNavigationRequest () {
    this.WriteAuditLog("Control ClearPendingNavigationRequest");

    this.PendingNavigationRequest = null;
}

function Controller_IsThereAPendingNavigationRequest () {
    return this.PendingNavigationRequest !== null;
}

function Controller_DeliverActivity (activity) {
    var logParent;

    this.WriteAuditLog("**************************************");
    this.WriteAuditLog("Deliverying Activity - " + activity);
    this.WriteAuditLog("**************************************");

    logParent = this.WriteAuditLog("Control DeliverActivity - " + activity);

    if (activity.IsDeliverable() === false) {
        Debug.AssertError("ERROR - Asked to deliver a non-leaf activity - " + activity);
    }

    //
    // If launch after click, the PopupLauncher will make these two calls once the course is actually viewed,
    // otherwise make the calls here as usual
    //
    if (Control.Package.Properties.ScoLaunchType !== LAUNCH_TYPE_POPUP_AFTER_CLICK
        && Control.Package.Properties.ScoLaunchType !== LAUNCH_TYPE_POPUP_AFTER_CLICK_WITHOUT_BROWSER_TOOLBAR
    ) {
        this.Api.ResetState();
        this.Api.InitializeForDelivery(activity);
    }

    this.ScoLoader.LoadSco(activity);

    this.UpdateDisplay(false, false);

    this.WriteDetailedLog("Exiting Control Deliver Activity", logParent);
}

// For use with "Launch after click" -- called within popup launcher
function Controller_PerformDelayedDeliveryInitialization (activity) {
    this.Sequencer.ContentDeliveryEnvironmentActivityDataSubProcess(activity);

    this.Api.ResetState();
    this.Api.InitializeForDelivery(activity);
    this.EvaluatePossibleNavigationRequests();
}

function Controller_InitializePossibleNavigationRequests () {
    var logParent = this.WriteAuditLog("Initializing Possible Navigation Requests"),
        defaultNavRequestResult,
        arrayIndex,
        identifier,
        activity,
        itemId,
        id;

    //
    // If lookahead is disabled, we must automatically expose the navigation elements
    //
    if (Control.Package.Properties.LookaheadSequencerMode === LOOKAHEAD_SEQUENCER_MODE_DISABLE) {
        this.WriteDetailedLog("Lookahead Sequencer Mode Disabled", logParent);
        defaultNavRequestResult = true;
    }
    else {
        this.WriteDetailedLog("Lookahead Sequencer Mode Enabled", logParent);
        defaultNavRequestResult = RESULT_UNKNOWN;
    }

    this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_START] = new PossibleRequest(NAVIGATION_REQUEST_START, null, defaultNavRequestResult, "", "");
    this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_RESUME_ALL] = new PossibleRequest(NAVIGATION_REQUEST_RESUME_ALL, null, defaultNavRequestResult, "", "");
    this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_CONTINUE] = new PossibleRequest(NAVIGATION_REQUEST_CONTINUE, null, defaultNavRequestResult, "", "");
    this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_PREVIOUS] = new PossibleRequest(NAVIGATION_REQUEST_PREVIOUS, null, defaultNavRequestResult, "", "");
    this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_EXIT] = new PossibleRequest(NAVIGATION_REQUEST_EXIT, null, defaultNavRequestResult, "", "");
    this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_EXIT_ALL] = new PossibleRequest(NAVIGATION_REQUEST_EXIT_ALL, null, defaultNavRequestResult, "", "");
    this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_SUSPEND_ALL] = new PossibleRequest(NAVIGATION_REQUEST_SUSPEND_ALL, null, defaultNavRequestResult, "", "");
    this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_ABANDON] = new PossibleRequest(NAVIGATION_REQUEST_ABANDON, null, defaultNavRequestResult, "", "");
    this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_ABANDON_ALL] = new PossibleRequest(NAVIGATION_REQUEST_ABANDON_ALL, null, defaultNavRequestResult, "", "");

    arrayIndex = POSSIBLE_NAVIGATION_REQUEST_INDEX_CHOICE;

    for (identifier in this.Activities.SortedActivityList) {
        if (this.Activities.SortedActivityList.hasOwnProperty(identifier)) {
            activity = this.Activities.SortedActivityList[identifier];
            itemId = activity.GetItemIdentifier();

            this.PossibleNavigationRequests[arrayIndex] = new PossibleRequest(NAVIGATION_REQUEST_CHOICE, itemId, defaultNavRequestResult, "", "");

            arrayIndex += 1;
        }
    }

    for (id in this.PossibleNavigationRequests) {
        if (this.PossibleNavigationRequests.hasOwnProperty(id)) {
            this.WriteDetailedLog("Initialized " + this.PossibleNavigationRequests[id].toString(), logParent);
        }
    }

    this.Sequencer.InitializePossibleNavigationRequestAbsolutes(this.PossibleNavigationRequests, this.Activities.ActivityTree, this.Activities.SortedActivityList);
}

// This is the method that actually runs the Lookahead Sequencer
function Controller_EvaluatePossibleNavigationRequests (isActivityStillLoaded, invokeRunTimeNavRequestIfItWillNowSucceed) {
    var logParent,
        navRequest;

    if (typeof invokeRunTimeNavRequestIfItWillNowSucceed === "undefined" || invokeRunTimeNavRequestIfItWillNowSucceed === null) {
        invokeRunTimeNavRequestIfItWillNowSucceed = false;
    }

    //
    // copy regular sequencer's clean activity state to the look ahead sequencer's activity state
    //
    if (this.Package.Properties.LookaheadSequencerMode !== LOOKAHEAD_SEQUENCER_MODE_DISABLE) {
        logParent = this.WriteAuditLog("Control Evaluate Possible Navigation Requests");

        this.WriteDetailedLog("Tearing down sequencer", logParent);
        this.TearDownSequencer(this.LookAheadSequencer);

        this.WriteDetailedLog("Cloning sequencer", logParent);
        this.LookAheadSequencer = this.CloneSequencer(this.Sequencer);
        this.LookAheadSequencer.LookAhead = true;

        this.WriteDetailedLog("Setting sequencer pointer for cloned activities", logParent);
        this.LookAheadSequencer.Activities.SetSequencer(this.LookAheadSequencer, true);

        this.WriteDetailedLog("Performing sequencing look ahead evaluation", logParent);

        this.PossibleNavigationRequests = this.LookAheadSequencer.EvaluatePossibleNavigationRequests(this.PossibleNavigationRequests);

        this.WriteDetailedLog("Done Evaluating Possible Navigation Requests", logParent);

        if (invokeRunTimeNavRequestIfItWillNowSucceed === true) {
            if (this.PendingNavigationRequest === null) {
                if (this.Api !== null && this.Api.RunTimeData !== null && this.Api.RunTimeData.NavRequest !== SCORM_RUNTIME_NAV_REQUEST_NONE) {
                    navRequest = Control.FindPossibleNavRequestForRuntimeNavRequest(this.Api.RunTimeData.NavRequest);

                    this.WriteDetailedLog("Checking to see if the nav request (" + navRequest + ") from the runtime will succeed now after re-evaluating with current data.", logParent);

                    // eslint-disable-next-line max-depth
                    if (navRequest.WillSucceed === true) {
                        this.WriteDetailedLog("Nav request will succeed. Unloading SCO.", logParent);
                        Control.ScoHasTerminatedSoUnload();
                    }
                    else {
                        this.WriteDetailedLog("Nav request will NOT succeed. Leaving SCO loaded.", logParent);
                    }
                }
            }
        }

        if (typeof isActivityStillLoaded !== "undefined" && isActivityStillLoaded !== null && isActivityStillLoaded === true) {
            // use lookahead nav info = true, use lookahead activity data = true
            this.UpdateDisplay(true, true);
        }
        else {
            this.UpdateDisplay(true, false);
        }
    }
    else {
        logParent = this.WriteAuditLog("Bypassing Lookahead Sequencer processing because PackageProperties.LookaheadSequencerMode = disabled");
    }

    this.Api.IsLookAheadSequencerRunning = false;
    this.Api.RunLookAheadSequencerIfNeeded();
}

function Controller_FindPossibleChoiceRequestForActivity (activity) {
    var targetItemIdentifier = activity.GetItemIdentifier(),
        arrayIndex = POSSIBLE_NAVIGATION_REQUEST_INDEX_CHOICE,
        i;

    for (i = arrayIndex; i < this.PossibleNavigationRequests.length; i += 1) {
        if (this.PossibleNavigationRequests[i].TargetActivityItemIdentifier === targetItemIdentifier) {
            return this.PossibleNavigationRequests[i];
        }
    }

    Debug.AssertError("Could not locate possible choice request for activity-" + activity);

    return null;
}

function Controller_GetPossibleContinueRequest () {
    return this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_CONTINUE];
}

function Controller_GetPossiblePreviousRequest () {
    return this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_PREVIOUS];
}

function Controller_IsTargetValid (targetString) {
    var targetActivity = this.ParseTargetStringIntoActivity(targetString);

    if (targetActivity === null) {
        return false;
    }

    return true;
}

function Controller_IsChoiceRequestValid (target) {
    var targetActivity = this.ParseTargetStringIntoActivity(target),
        targetItemIdentifier = targetActivity.GetItemIdentifier(),
        i;

    for (i = POSSIBLE_NAVIGATION_REQUEST_INDEX_CHOICE; i < this.PossibleNavigationRequests.length; i += 1) {
        if (this.PossibleNavigationRequests[i].TargetActivityItemIdentifier === targetItemIdentifier) {
            return this.PossibleNavigationRequests[i].WillSucceed;
        }
    }

    return false;
}

function Controller_IsJumpRequestValid (target) {
    var targetActivity = this.ParseTargetStringIntoActivity(target);

    if (targetActivity !== null) {
        return targetActivity.IsAvailable();
    }

    return false;
}

function Controller_IsContinueRequestValid () {
    return this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_CONTINUE].WillSucceed;
}

function Controller_IsPreviousRequestValid () {
    return this.PossibleNavigationRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_PREVIOUS].WillSucceed;
}

function Controller_ParseTargetStringIntoActivity (value) {
    var itemIdentifier = this.ParseTargetStringFromChoiceRequest(value),
        targetActivity = this.Activities.GetActivityFromIdentifier(itemIdentifier);

    return targetActivity;
}

function Controller_ParseTargetStringFromChoiceRequest (value) {
    // TODO - test this....make more robust...check for case indexOf("=") < 0
    return value.substring(value.indexOf("=") + 1, value.indexOf("}"));
}

function Controller_CloneSequencer (sequencerToClone, resultIsLookAhead) {
    var sequencerReturn = new Sequencer(resultIsLookAhead, sequencerToClone.Activities.Clone()),
        objId;

    if (sequencerToClone.SuspendedActivity === null) {
        sequencerReturn.SuspendedActivity = null;
    }
    else {
        sequencerReturn.SuspendedActivity = sequencerReturn.Activities.GetActivityFromIdentifier(sequencerToClone.SuspendedActivity.GetItemIdentifier());
    }

    if (sequencerToClone.CurrentActivity === null) {
        sequencerReturn.CurrentActivity = null;
    }
    else {
        sequencerReturn.CurrentActivity = sequencerReturn.Activities.GetActivityFromIdentifier(sequencerToClone.CurrentActivity.GetItemIdentifier());
    }

    sequencerReturn.GlobalObjectives = [];

    for (objId in sequencerToClone.GlobalObjectives) {
        if (sequencerToClone.GlobalObjectives.hasOwnProperty(objId)) {
            sequencerReturn.GlobalObjectives[sequencerReturn.GlobalObjectives.length] = sequencerToClone.GlobalObjectives[objId].Clone();
        }
    }

    // TODO - find a cleaner way to copy properties that are specific to one sequencer or another
    if (typeof sequencerToClone.AtEndOfCourse !== "undefined") {
        sequencerReturn.AtEndOfCourse = sequencerToClone.AtEndOfCourse;
        sequencerReturn.AtStartOfCourse = sequencerToClone.AtStartOfCourse;
    }

    sequencerReturn.NavigationRequest = null;
    sequencerReturn.ChoiceTargetIdentifier = null;
    sequencerReturn.Exception = null;
    sequencerReturn.ExceptionText = null;

    return sequencerReturn;
}

function Controller_TearDownSequencer (sequencer) {
    sequencer.LookAhead = null;

    if (sequencer.Activities !== null) {
        sequencer.Activities.TearDown();
    }

    sequencer.Activities = null;
    sequencer.NavigationRequest = null;
    sequencer.ChoiceTargetIdentifier = null;
    sequencer.SuspendedActivity = null;
    sequencer.CurrentActivity = null;
    sequencer.Exception = null;
    sequencer.ExceptionText = null;
    sequencer.GlobalObjectives = null;
}

function Controller_WriteAuditLog (str) {
    Debug.WriteControlAudit(str);
}

function Controller_WriteDetailedLog (str, parent) {
    Debug.WriteControlDetailed(str, parent);
}

function Controller_WriteDetailedLogError (str, parent) {
    Debug.WriteControlDetailed(str, parent, true);
}

function Controller_WriteHistoryLog (str, atts) {
    HistoryLog.WriteEventDetailed(str, atts);
}

function Controller_WriteHistoryReturnValue (str, atts) {
    HistoryLog.WriteEventDetailedReturnValue(str, atts);
}

function Controller_GetLaunchHistoryId () {
    return rscpCfg.get("launchHistoryId");
}

//
// finds and returns the control object. Needed to handle the scormengine being
// launched within an external frameset. Used by MenuItem.
//
// eslint-disable-next-line no-unused-vars
function GetController () {
    var MAX_PARENTS_TO_SEARCH = 500,
        nParentsSearched = 0,
        win = window,
        result;

    while (win.Control === null && win.parent !== null && win.parent !== win && nParentsSearched <= MAX_PARENTS_TO_SEARCH) {
        nParentsSearched += 1;
        win = win.parent;
    }

    if (typeof win.Control === "undefined" || win.Control === null) {
        Debug.AssertError("Could not locate the Control object.");
    }
    else {
        result = win.Control;
    }

    return result;
}

function Controller_UpdateGlobalLearnerPrefs () {
    var preferenceArray,
        preferenceName,
        activityIterator,
        activity;

    if (this.Api.LearnerPrefsArray !== "undefined" && this.Api.LearnerPrefsArray !== null) {
        preferenceArray = this.Api.LearnerPrefsArray;

        for (preferenceName in preferenceArray) {
            if (preferenceArray.hasOwnProperty(preferenceName)) {
                for (activityIterator in this.Activities.ActivityList) {
                    // eslint-disable-next-line max-depth
                    if (this.Activities.ActivityList.hasOwnProperty(activityIterator)) {
                        activity = this.Activities.ActivityList[activityIterator];

                        // eslint-disable-next-line max-depth
                        if (activity.RunTime !== null && activity.RunTime[preferenceName] !== preferenceArray[preferenceName]) {
                            activity.RunTime[preferenceName] = preferenceArray[preferenceName];
                            activity.RunTime.SetDirtyData();
                        }
                    }
                }
            }
        }
    }
}

//
// Time Limit and related functionality...
//
function Controller_IsUserOverTimeLimit () {
    var rootActivity,
        experiencedDurationTracked,
        currentTrackedTimeHundredths,
        runningTotalHundredths,
        timeLimitHundredths;

    if (this.Package.Properties.TimeLimit <= 0) {
        return false;
    }

    rootActivity = this.Activities.GetRootActivity();
    if (rootActivity === null) {
        return false;
    }

    // TODO: Option to use reported time instead?
    experiencedDurationTracked = ConvertIso8601TimeSpanToHundredths(rootActivity.GetActivityExperiencedDurationTracked());

    //
    // Calculate tracked time so far. If the tracked start date on the Api object hasn't been initialized, then we haven't
    // started, so the tracked time should be zero
    //
    if (this.Api.TrackedStartDate === null) {
        currentTrackedTimeHundredths = 0;
    }
    else {
        currentTrackedTimeHundredths = Math.round((new Date() - this.Api.TrackedStartDate) / 10);
    }

    runningTotalHundredths = experiencedDurationTracked + currentTrackedTimeHundredths;

    // Time limit is specified in minutes
    timeLimitHundredths = this.Package.Properties.TimeLimit * 60 * 100;

    return runningTotalHundredths > timeLimitHundredths;
}

// This is run on a regular interval, see Control.Initialize()
function Controller_ExitIfTimeLimitExceeded () {
    if (this.IsUserOverTimeLimit() === true) {
        this.WriteAuditLog("Time limit exceeded, automatically returning user from the course");

        // Only show the message once
        if (this.MessageShown !== true) {
            // TODO: translate
            // eslint-disable-next-line no-alert
            alert("You have exceeded the time limit for this course, your session will now end.");
            this.MessageShown = true;
        }
        this.TriggerReturnToLMS();
    }
}

//
// Disables all navigation options and displays the message using a
// NAVIGATION_REQUEST_DISPLAY_MESSAGE NavigationRequest
//
function Controller_BlockCourseEntryWithMessage (messageText) {
    var activityId,
        menuItem,
        i;

    this.Sequencer.NavigationRequest = new NavigationRequest(NAVIGATION_REQUEST_DISPLAY_MESSAGE, null, messageText);

    for (activityId in this.Sequencer.Activities.ActivityList) {
        if (this.Sequencer.Activities.ActivityList.hasOwnProperty(activityId)) {
            this.Sequencer.Activities.ActivityList[activityId].SetHiddenFromChoice(true);

            menuItem = this.Sequencer.Activities.ActivityList[activityId].MenuItem;
            if (menuItem !== null) {
                menuItem.Disable();
            }
        }
    }

    for (i = 0; i < this.PossibleNavigationRequests.length; i += 1) {
        this.PossibleNavigationRequests[i].WillSucceed = false;
    }

    IntegrationImplementation.UpdateControlState(IntegrationImplementation.GetDocumentObjectForControls(), this.PossibleNavigationRequests, null);
}
